/* Lightweight event bus that bridges sonner-style toast calls to the
   global <FeedbackOverlay/>. Used by the patched `toast.success` /
   `toast.error` so that every existing call site (356 across the app)
   automatically shows the new yes.png / no.png feedback overlay without
   needing edits per file.

   API:
     feedbackBus.show("success" | "error", message)
     feedbackBus.subscribe(handler) → unsubscribe fn
*/

const listeners = new Set();

const feedbackBus = {
  show(kind, message) {
    const ev = { id: Date.now() + Math.random(), kind, message: String(message ?? "") };
    listeners.forEach((fn) => {
      try { fn(ev); } catch { /* one bad listener shouldn't break the rest */ }
    });
  },
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

export default feedbackBus;
